import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { AgendaVisitEndHour, AgendaVisitStartHour } from 'utils/constants';
import {
  CustomFormTextField,
  DropDownArrow,
  DropDownContainer,
  DropDownHeader,
  DropDownList,
  DropDownListContainer,
  ListItem,
} from './TimeInputStyles';
import { IconButton, Typography } from '@mui/material';

const defaultStart = {
  value: AgendaVisitStartHour,
  label: AgendaVisitStartHour,
};

const defaultEnd = {
  value: AgendaVisitEndHour,
  label: AgendaVisitEndHour,
};

const TimeInput = ({
  control,
  label,
  theme,
  getValues,
  setValue,
  keyName,
  customStyle,
  togglingIsOpen,
  isEnd = false,
  defaultValue,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggling = () => {
    togglingIsOpen?.(!isOpen);
    setIsOpen(!isOpen);
  };

  const hours = Array.from({ length: 24 }, (_, i) => i).filter(
    (i) => i > 8 && i < 19 && i
  );
  const minutes = ['00', '30'];
  const options = hours
    .map((hour) =>
      minutes.map((minute) => ({
        value: `${('0' + hour).slice(-2)}:${minute}`,
        label: `${('0' + hour).slice(-2)}:${minute}`,
      }))
    )
    .flat();

  const renderList = ({ onSelect }) => (
    <DropDownListContainer customTheme={theme}>
      <DropDownList customTheme={theme}>
        {options
          ? options
              .filter(
                (_, idx) =>
                  idx !== 0 && (!isEnd ? idx !== options.length - 1 : true)
              )
              .map((option, idx) => (
                <ListItem
                  customTheme={theme}
                  onClick={() => {
                    {
                      togglingIsOpen?.(false);
                      setIsOpen(false);
                      onSelect && onSelect(option.value);
                    }
                  }}
                  key={idx}
                >
                  <Typography margin={0} variant={'body2'}>
                    {option.label}
                  </Typography>
                </ListItem>
              ))
          : null}
      </DropDownList>
    </DropDownListContainer>
  );

  const handleOnBlur = (blurValue = '') => {
    const value = blurValue || getValues(keyName);
    const isHour = /^([01][0-9]|2[0-3]):[0-5][0-9]$/.test(value);
    const defaultCurrentValue =
      keyName === 'morningStart' ? defaultStart.value : defaultEnd.value;
    if (!isHour) {
      const splitted = value.split(':');
      if (splitted?.length === 1) {
        // sono stati cancellati i due punti
        if (splitted?.[0].length < 4) {
          let half = splitted?.[0];
          for (let index = splitted?.[0].length; index < 4; index++) {
            half = half + '0';
          }
          return handleOnBlur(half);
        } else {
          const singleHour = splitted?.[0];
          const output = [
            singleHour.slice(0, 2),
            ':',
            singleHour.slice(2),
          ].join('');
          return handleOnBlur(output);
        }
      } else if (splitted?.length === 2) {
        // i due punti ci sono
        const correctedHour = splitted.map((v, idx) => {
          const isHourValue = idx === 0;
          const isMinutesValue = idx === 1;
          const valueToBeCheck = `${
            isHourValue ? v : defaultCurrentValue.split(':')[0]
          }:${isMinutesValue ? v : defaultCurrentValue.split(':')[1]}`;
          const isValid = /^([01][0-9]|2[0-3]):[0-5][0-9]$/.test(
            valueToBeCheck
          );
          if (isHourValue) {
            return isValid ? v : defaultCurrentValue.split(':')[0];
          } else {
            return isValid ? v : defaultCurrentValue.split(':')[1];
          }
        });
        setValue(keyName, correctedHour.join(':'));
      } else {
        setValue(keyName, defaultCurrentValue);
      }
    }
    if (blurValue && isHour) {
      setValue(keyName, blurValue);
    }
    setIsOpen(false);
    togglingIsOpen?.(false);
  };

  return (
    <Controller
      name={keyName}
      control={control}
      defaultValue={defaultValue}
      rules={{ required: true }}
      render={(props) => (
        <DropDownContainer customTheme={theme} customStyle={customStyle}>
          <DropDownHeader customTheme={theme}>
            <CustomFormTextField
              variant="standard"
              customTheme={theme}
              placeholder={label}
              value={props.value}
              onChange={(e) => {
                props.onChange(e.target.value);
              }}
              onBlur={() => handleOnBlur()}
            />
            <DropDownArrow onClick={toggling} customTheme={theme}>
              {isOpen ? (
                <IconButton
                  disableFocusRipple
                  disableTouchRipple
                  disableRipple
                  sx={{ paddingRight: 0, color: 'black' }}
                >
                  <ArrowDropUpIcon fontSize="small" color="inherit" />
                </IconButton>
              ) : (
                <IconButton
                  disableFocusRipple
                  disableTouchRipple
                  disableRipple
                  sx={{ paddingRight: 0, color: 'black' }}
                >
                  <ArrowDropDownIcon fontSize="small" color="inherit" />
                </IconButton>
              )}
            </DropDownArrow>
            {isOpen && renderList({ onSelect: props.onChange })}
          </DropDownHeader>
        </DropDownContainer>
      )}
    />
  );
};

export default TimeInput;
